export const isActivityLoggingEnabled = (
  value: string | undefined = process.env.REACT_APP_ACTIVITY_LOGGING_ENABLED,
): boolean => value === "true";
